module.exports = __webpack_public_path__ + "img/11.9137180c.jpg";